module.exports = __webpack_public_path__ + "cdf21da2e024e2abb366b77a16f2b473.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/power_has_a_price-1050.webp
// module id = 505
// module chunks = 0